import { isFedRamp } from '@atlassian/atl-context';
import { isDisableDevopsFeaturesInFedRampEnvEnabled } from './feature-flags';

export const isDevopsFeatureDisabledInFedRamp = () =>
	isDisableDevopsFeaturesInFedRampEnvEnabled() && isFedRamp();
